import axios from "axios";
import { Dispatch } from "redux";

import {
  FilterActionTypes,
  GET_FILTER_DATA_REQUEST,
  GET_FILTER_DATA_SUCCESS,
  GET_FILTER_DATA_FAILURE,
  SET_SIDEBAR_FILTERS,
  RESET_SIDEBAR_FILTERS,
} from "../types/filterTypes";

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });
API.defaults.withCredentials = true;

export const fetchFilterData =
  () => async (dispatch: Dispatch<FilterActionTypes>) => {
    dispatch({ type: GET_FILTER_DATA_REQUEST, payload: [] });

    try {
      const response = await API.get("/filter_data", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      dispatch({
        type: GET_FILTER_DATA_SUCCESS,
        payload: response.data,
      });
    } catch (error: any) {
      dispatch({
        type: GET_FILTER_DATA_FAILURE,
        payload: error.response?.data?.message || "Failed to fetch filter data",
      });
    }
  };

export const setSidebarFilters = (filters: any) => ({
  type: SET_SIDEBAR_FILTERS,
  payload: filters,
});

export const setResetSidebarFilters = (filters: any) => ({
  type: RESET_SIDEBAR_FILTERS,
  payload: filters,
});
